import { getCSRFToken, fetchCSRFToken } from "./csrf";

const BASE_URL = "/api/_allauth/browser/v1";

async function request(method, endpoint, data = null) {
  let csrfToken = getCSRFToken();

  if (!csrfToken) {
    await fetchCSRFToken();
    csrfToken = getCSRFToken();
  }

  const headers = {
    "Content-Type": "application/json",
    "X-CSRFToken": csrfToken,
  };

  const options = {
    method,
    headers,
    credentials: "include",
  };

  if (data) options.body = JSON.stringify(data);

  const response = await fetch(`${BASE_URL}${endpoint}`, options);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.errors?.[0]?.message || "Something went wrong.");
  }

  return response.json();
}

export async function signUp({ email, username, password }) {
  return request("POST", "/auth/signup", { email, username, password });
}
export async function signIn({ email, password }) {
  return request("POST", "/auth/login", { email, password });
}

export async function verifyEmail({ key }) {
  try {
    let csrfToken = getCSRFToken();
    if (!csrfToken) {
      await fetchCSRFToken();
      csrfToken = getCSRFToken();
    }

    const response = await fetch(`${BASE_URL}/auth/email/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
      body: JSON.stringify({ key }),
    });
    const data = await response.json().catch(() => ({}));
    return { status: response.status, data };
  } catch (error) {
    return { status: 0, data: {}, message: error.message };
  }
}

export async function requestPassword (email) {
   try {

    let csrfToken = getCSRFToken();
    if (!csrfToken) {
      await fetchCSRFToken();
      csrfToken = getCSRFToken();
    }

      const response = await fetch(`${BASE_URL}/auth/password/request`, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
      body: JSON.stringify({ email }),
      });

      const data = await response.json().catch(() => ({}));
      return { status: response.status, ok: response.ok, data };
   } catch (error) {
      console.error(error);
      return error;
   }
}

export async function getPasswordResetInfo (key) {
   try {

    let csrfToken = getCSRFToken();
    if (!csrfToken) {
      await fetchCSRFToken();
      csrfToken = getCSRFToken();
    }

      const response = await fetch(`${BASE_URL}/auth/password/reset`, {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
        "X-Password-Reset-Key": key,
      },
      credentials: "include",
      });

      const data = await response.json().catch(() => ({}));
      return { status: response.status, ok: response.ok, data };
   } catch (error) {
      console.error(error);
      return { status: 0, ok: false, data: {}, message: error.message };
  }  
}

export async function resetPassword (key, password) {
   try {

    let csrfToken = getCSRFToken();
    if (!csrfToken) {
      await fetchCSRFToken();
      csrfToken = getCSRFToken();
    }

      const response = await fetch(`${BASE_URL}/auth/password/reset`, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
      body: JSON.stringify({ key, password }),
      });

      const data = await response.json().catch(() => ({}));
      return { status: response.status, ok: response.ok, data };
   } catch (error) {
      console.error(error);
      return { status: 0, ok: false, data: {}, message: error.message };
  }  
}